<template>
  <CCard class="mob-pd-0px">
    <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
      <CRow class="flex-flow-column">
        <CCol >
          <strong>{{ $t("bookingManifest.title") }}</strong>
        </CCol>
        
        <p class="desc" >
          {{ $t("bookingManifest.desc")}}
        </p>
      </CRow>
      <div v-if="manifestLs && manifestLs.length!=0"
        @click="toggleJsonExcelModal()"
        class="generate-ex-btn"
      >
        <img src="@imgPath/img/svg/icons/excle-icon.svg" alt />
      </div>
    </CCardHeader>
    <CCardBody class="user-manage-table pt-0px ticketing_queue_p">
      <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row tq-header-nav">
          <div class="col" md="8">
            <div class="row">
              <!-- departure -->
        <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
          <br />
             <ValidationProvider :rules="'required'" v-slot="{ errors }">
              <multiselect
                :allow-empty="false"
                :showLabels="false"
                :clearOnSelect="false"
                v-model="reportObj.depCode"
                :options="lsCountryRoute"
                :multiple="false"
                group-values="routeList"
                group-label="country"
                :group-select="false"
                :placeholder="$t('bookingManifest.departure')"
                track-by="depcode"
                v-on:input="getDepartureRoute"
                class="mt-auto"
                ref="fromCityPicker"
                :searchable="true"
                :custom-label="cityPickCustomeLabel"
                @search-change="addCssClass()"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  >{{ option.depcode.city }} ({{
                    option.depcode.airportcode
                  }})</template
                >
                <template slot="option" slot-scope="props">
                  <div>
                    <span v-if="props.option.$isLabel">{{
                      props.option.$groupLabel.value
                    }}</span>
                    <span v-else>
                      {{ props.option.depcode.city }}
                      <strong v-if="props.option.depcode" class="right">{{
                        props.option.depcode.airportcode
                      }}</strong>
                    </span>
                  </div>
                </template>
                <span slot="noResult"
                  ><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span
                >
              </multiselect>
               <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
          </div> 
          <!-- arrival -->
        <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12"> 
             <br />
            <ValidationProvider :rules="'required'" v-slot="{ errors }">
              <multiselect
                class="mt-auto"
                :allow-empty="false"
                :showLabels="false"
                :clearOnSelect="false"
                v-model="reportObj.arrCode"
                :options="lsCountryRoute"
                :multiple="false"
                group-values="routeList"
                group-label="country"
                :group-select="false"
                :placeholder="$t('bookingManifest.arrival')"
                track-by="depcode"
                v-on:input="getArrivalRoute"
                ref="fromCityPicker"
                :searchable="true"
                :custom-label="cityPickCustomeLabel"
                @search-change="addCssClass()"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  >{{ option.depcode.city }} ({{
                    option.depcode.airportcode
                  }})</template
                >
                <template slot="option" slot-scope="props">
                  <div>
                    <span v-if="props.option.$isLabel">{{
                      props.option.$groupLabel.value
                    }}</span>
                    <span v-else>
                      {{ props.option.depcode.city }}
                      <strong v-if="props.option.depcode" class="right">{{
                        props.option.depcode.airportcode
                      }}</strong>
                    </span>
                  </div>
                </template>
                <span slot="noResult"
                  ><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span
                >
              </multiselect>
              <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
        </div> 

        <!-- flight number -->
        <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
                <br />
                <ValidationProvider :rules="'required'" v-slot="{ errors }">
            <multiselect
                      class="mt-auto"
                      :allow-empty="false"
                      :showLabels="false"
                      :clearOnSelect="false"
                      v-model="reportObj.flightNumber"
                      :options="lsFlightNum"
                      :multiple="false"
                      :group-select="false"
                      :placeholder="$t('bookingManifest.selFlight')"
                      :track-by="'id'"
                      v-on:input="onChangeFlightNumber"
                      ref="fromCityPicker"
                      :searchable="true"
                      :label="'flight_number'"
                      @search-change="addCssClass()"
                    >
                      <template slot="singleLabel" slot-scope="{ option }"
                  >{{ option.flight_number }} 
                  <strong class="right" >{{ option.depcode +' - '+ option.arrcode}}</strong></template
                >
                <template slot="option" slot-scope="props">
                  <div>
                    <div><span>{{ props.option.flight_number }}</span>
                    <strong class="right" >{{ props.option.depcode +' - '+ props.option.arrcode}}</strong>
                </div>
                  </div>
                </template>
                      <span slot="noResult"
                        ><strong>{{
                          $t("noMatchFound.noMatchFound")
                        }}</strong></span
                      >
                    </multiselect> 
                    <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
        </div> 

           <!-- departure date  -->
           <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
             <div>
                  <label  class="title d-flex justify-content-between max-w-400" ></label>
                  <br />
                </div>
            
                <!-- <div class="ext-date-wrapper" >
                  <v-md-date-range-picker
                    :start-date="travelDateFrom
                        ? travelDateFrom.toString()
                        : new Date().toString()
                    "
                    :end-date="travelDateTo
                        ? travelDateTo.toString()
                        : new Date().toString()
                    "
                    :autoApply="true"
                    :showYearSelect="true"
                    :maxYear="getMaxYear(true)"
                    :minYear="getMinYear()"
                    @change="onChangeTravelDate"
                  >
                    <template slot="input">
                      <datePickerInput
                        @click.native="onToggleTravelDatePicker"
                        :fromDate="
                          travelDateFrom
                            ? travelDateFrom
                            : null
                        "
                        :toDate="
                         travelDateTo ? travelDateTo : null
                        "
                        :fromLabel="$t('bookingManifest.fromDateLabel')"
                        :toLabel="$t('bookingManifest.toDateLabel')"
                      />
                    </template>
                  </v-md-date-range-picker>
                </div> -->
             
             <date-picker  v-model="travelDateFrom" @input="getFromDate" :masks="masks">
               <div slot-scope="props">

            <input class="col datepickerinput" :placeholder="$t('bookingManifest.depDate')" :value="props.inputValue" />
                 </div>
              </date-picker>
           </div>

          <!-- flight schedule -->
            <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
              <br />
             <multiselect
                      class="mt-auto"
                      :allow-empty="false"
                      :showLabels="false"
                      :clearOnSelect="false"
                      v-model="reportObj.depTime"
                      :options="lsFlightTime"
                      :multiple="false"
                      :label="'deptime'"
                      :group-select="false"
                      :placeholder="$t('bookingManifest.schedule')"
                      track-by="id"
                      ref="fromCityPicker"
                      :searchable="true"
                      
                      @search-change="addCssClass()"
                    >
                           <template slot="singleLabel" slot-scope="{ option }"
                  >{{  option.deptime?option.deptime.substring(0,5):null }} 
                  <strong class="right" >{{ option.flight_number}}</strong></template
                >
                <template slot="option" slot-scope="props">
                  <div>
                    <div><span>{{ props.option.deptime?props.option.deptime.substring(0,5):null}}</span>
                    <strong class="right" >{{ props.option.flight_number}}</strong>
                </div>
                  </div>
                </template>
                      <span slot="noResult"
                        ><strong>{{
                          $t("noMatchFound.noMatchFound")
                        }}</strong></span
                      >
             </multiselect>
          
            </div>
        <CCol md="3" class="d-flex align-center">
          <div class="d-flex align-center w-100 action-btn-tq">
            <div>
              <CButton type="submit" @click.prevent="handleSubmit(onApply)" class="btn-outline-success ml-0px">
                {{ $t("bookingManifest.submit") }}
              </CButton>
            </div>
            <div
              @click="isShowMoreFilter = !isShowMoreFilter"
              class="mr-10px more-btns"
              :class="{ rotate: isShowMoreFilter }"
            >
              <span>
                {{ $t("bookingManifest.more") }}
                <div>{{ $t("bookingManifest.filter") }}</div>
              </span>
            </div>
          </div>
        </CCol>
      </div>
          </div>
        </div>
        <CCol md="12" class="multisele-max-40-h">
          <CCollapse :show="isShowMoreFilter">
            <CRow class="extra-filters">
              <CCol md="12">
                <CRow>
                  <CCol md="2" sm="6" class="mt-2">
                    <cTextInputComponent
                      v-model="reportObj.pnr"
                      :placeholder="$t('bookingManifest.pnr')"
                      class="w-100"
                    ></cTextInputComponent>
                  </CCol>
                  <CCol md="2" sm="6" class="mt-2">
                    <cTextInputComponent
                      v-model="reportObj.ticketNumber"
                      :placeholder="$t('bookingManifest.ticketNumber')"
                    ></cTextInputComponent>
                  </CCol>

                  <!-- <CCol md="2" sm="6" class="tq-date-picker mt-2"> -->
                     <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
             <div>
                  <label  class="title d-flex justify-content-between max-w-400" >{{ $t("bookingManifest.BookingDate") }}</label>
                </div>
                    <div class="ext-date-wrapper">
                    

                      <v-md-date-range-picker
                        :start-date="
                        bookingDateFrom
                            ?bookingDateFrom.toString()
                            : new Date().toString()
                        "
                        :end-date="
                          bookingDateTo
                            ? bookingDateTo.toString()
                            : new Date().toString()
                        "
                        :autoApply="true"
                        :showYearSelect="true"
                        :maxYear="getMaxYear()"
                        :minYear="getMinYear()"
                        @change="onChangeBookingDate"
                        :ref="'manifestdatePicker'"
                      >
                        <template slot="input">
                          <datePickerInput
                          
                            :fromDate="
                              bookingDateFrom
                                ? bookingDateFrom
                                : null
                            "
                            :toDate="
                              bookingDateTo
                                ? bookingDateTo
                                : null
                            "
                            :fromLabel="$t('bookingManifest.fromDateLabel')"
                            :toLabel="$t('bookingManifest.toDateLabel')"
                          />
                        </template>
                      </v-md-date-range-picker>
                    </div>
                     </div>
                  <!-- </CCol> -->

                 
           <!-- contract -->

            <div class="multiselect-assignprice col align-center text-left mt-2" md="3" sm="6" xs="12">
         <br />
         <multiselect
                class="multiselect-assignprice"
                :searchable="true"
                :close-on-select="true"
                :track-by="'contractid'"
                :label="'contractcode'"
                v-model="reportObj.contractIds"
                :multiple="true"
                :allow-empty="true"
                :show-labels="false"
                :options="contractLs"
                :placeholder="$t('contract.selectContract')"
                v-on:input="onContractChange"
              >
                <template slot="option" slot-scope="props">
                  <div class="d-flex">
                    <span>{{ props.option['contractcode'] }}</span>
                    <!-- <strong class="right ml-auto">
                                        {{
                                        props.option['contractcode']
                                        }}
                    </strong>-->
                  </div>
                </template>
                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
              </multiselect>   
         </div>
                  <CCol md="2" class="filter-wrap-tq">
                    <div class="clear-filter-btn" @click="clearFilter()">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 492 492"
                          style="
                            fill: rgb(30, 144, 255);
                            enable-background: new 0 0 492 492;
                          "
                          xml:space="preserve"
                        >
                          <g>
                            <g>
                              <path
                                d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"
                              />
                            </g>
                          </g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                        </svg>

                        {{ $t("bookingManifest.clearAll") }}
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCollapse>
        </CCol>
      
      </ValidationObserver>
      
      <CRow >
        <CCol>
          <cTable
            :items="manifestLs"
            :fields="tableFields"
            caption="BookingManifestReport"
            items-per-page-select
            :items-per-page="manifestTableWatchList.itemsPerPage"
            hover
            :sorter="{ resetable: true }"
            :class="'mt-0'"
            pagination
            class="usersTable border-grey manage-user-table table table-striped table-hover"
            id="user-manage-table"
            @filtered-items-change="getFilteredAgentCount"
            @page-change="onPageChange"
            @pagination-change="onPaginationChange"
           :loading="isLoading"
            @getFields="onSaveColumns"
            :tableWatchList="manifestTableWatchList"
            :manageColumn="true"
            :paginationLenOption="true"
            :activePage="manifestTableWatchList.currentPageNum"
          >
            
            <template #no-items-view>
              <div class="text-center my-5">
                <h3>
                {{ isLoading?'':isFiltersApplied ?  $t('bookingManifest.noListFilter') : 'Apply filters to view your bookings'   }}
                </h3>
              </div>
            </template>
           
            <template #bookingDatetime="{ item }">
              <td class="py-2">
                <div v-if="item.arrdate">
                  <span>{{ item.arrdate | formatDate  }}</span>
                </div>
                <div v-if="item.arrtime">
                  {{
                    item.arrtime.substring(0,5)
                  }}
                </div>
              </td>
            </template>
           <template #depDateTime="{ item }">
              <td class="py-2">
                <div v-if="item.depdate">
                  {{ item.depdate | formatDate  }}
                </div>
                <div v-if="item.deptime">
                  {{
                    item.deptime.substring(0,5)
                  }}
                </div>
              </td>
            </template>
             <template #paxName="{ item }">
              <td class="py-2">
                <div v-if="item.firstname">
                  {{ item.firstname +' '+ item.lastname }}
                </div>
                
              </td>
            </template>
            <template #gender="{ item }">
              <td class="py-2">
                <div v-if="item.gender">
                  {{ item.gender }}
                </div>
                <div v-else>
                  -
                </div>
                
              </td>
            </template>
            <template #dob="{ item }">
              <td class="py-2">
                <div v-if="item.dob">
                 {{ item.dob | formatDate }}
                </div>
                <div v-else>
                  -
                </div>
                
              </td>
            </template>
             <template #id_expirydate="{ item }">
              <td class="py-2">
                <div v-if="item.id_expirydate">
                  {{ item.id_expirydate }}
                </div>
                <div v-else>
                  -
                </div>
                
              </td>
            </template>
             <template #contact_email="{ item }">
              <td class="py-2">
                <div v-if="item.contact_email">
                  {{ item.contact_email }}
                </div>
                <div v-else>
                  -
                </div>
                
              </td>
            </template>
            <template #mobilenumber="{ item }">
              <td class="py-2">
                <div v-if="item.contact_mobile_number">
                  <span>{{item.contact_mobile_code?item.contact_mobile_code:null}}{{item.contact_mobile_number }}</span>
                </div>
                 <div v-else>
                  <span>-</span>
                </div>
              </td>
            </template>
            
          </cTable>
        </CCol>
      </CRow>
    </CCardBody>
     <cJsonExcelModal
        v-if="showJsonExcelModal"
        :show="showJsonExcelModal"
        :desc="$t('jsonExcelModal.desc', { name: 'Booking Manifest' })"
        :onCancel="toggleJsonExcelModal"
      >
        <template #jsonExcel>
          <div @click="toggleJsonExcelModal()">
            <cExportExcel
              :data="manifestLs"
              :fields="getJsonExcelFields()"
              worksheet="Booking Manifest"
              :name="getExcelFileName('Booking Manifest')"
            >{{ $t("jsonExcelModal.download") }}</cExportExcel>
          </div>
        </template>
      </cJsonExcelModal>
  </CCard>
</template>

<script>
import cReport from "../../../components/report/cReport";
import {
  PATHNAME,
  COMPONENT_NAME,
  ALERT_MODAL_STATUS,
  ORDER,
  DATE_TIME_FORMAT,
} from "../../../../src/util/constants";
import apiGetPostpaidReport from "../../../../src/services/apiGetPostpaidReport";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import {
  addClassToBody,
  removeClassBody,
  handleJWT,
  getErrorAlertValue,
  cloneDeep,
  cloneData,
  OrderByList,GroupByList
} from "../../../../src/util/util";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../config/API_DATA";
import Logger from "../../../services/logger";
import BaseConfiguration from "../../../config/base.js";
import cManageColumns from "../../../components/dataTable/cManageColumns";
import cTable from "../../../components/dataTable/cTable";
import apiGetAllContract from "../../../services/apiGetAllContract";
import cAlertModal from "../../../components/form/cAlertModal";
import cPaginationLenOption from "../../../components/dataTable/cPaginationLenOption";
import datePickerInput from "../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";
import { mapGetters, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-range-datechooser";
import { formatDate } from "../../../util/date/dateFunctions";
import cTextInputComponent from "../../../components/form/cTextInputComponent";
import cAirLine from "../../../components/pricing/cAirLine";
import cJsonExcelModal from "../../../components/modal/cJsonExcelModal";
  import cExportExcel from '../../../components/excel/cExportExcel'
import apiBookingManifestReport from "../../../services/apiBookingManifestReport";
import apiGetRoutes from "../../../services/apiGetRoutes";
import apiCrsFlightNumwithRoute from "../../../services/apiCrsFlightNumwithRoute";
import apiCrsFlightTimingwithRoute from "../../../services/apiCrsFlightTimingwithRoute";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  name: COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
  components: {
    Multiselect,
    cAlertModal,
    HotelDatePicker,
    cTextInputComponent,
    cAirLine,
    cPaginationLenOption,
    datePickerInput,
    VMdDateRangePicker,
    cManageColumns,
    cTable,
    cReport,
    ValidationObserver,
    ValidationProvider,
    cJsonExcelModal,
    cExportExcel,
    DatePicker,
  },
  data: () => {
    return {
       masks: {
        input: "DD-MMM-YYYY",
      },
      isLoading: false,
      showJsonExcelModal:false,
      reportObj:{
         depCode: null,
         arrCode: null,
         flightNumber: null,
         depDate: null,
         depTime: null,
         contractIds: null,
         pnr: null,
         ticketNumber: null,
         reportStartDate: null,
         reportEndDate: null
        },
        travelDateFrom:null,
        travelDateTo:null,
        bookingDateFrom:null,
        bookingDateTo:null,
      reportName: COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
      lsReportData: null,
      lsReportTableData: null,
      lsFlightNum:[],
      lsFlightTime:[],
      manifestLs:[],
      contractLs:[],
      fieldsToTotal: [],
       isFiltersApplied:false,
      manifestTableWatchList:{
                    filteredlistCount:null,
                    itemsPerPage:25,
                    currentPageNum:1
                },
                tableFields:null,
      routesResponse:null,
                lsCountryRoute:[],
                isShowMoreFilter: false,
    };
    
   
  },

 
  methods: {

       getFromDate(selectedDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        this.travelDateFrom = selectedDate;
            
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in getFromDate ",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getExcelFileName(pFileName) {
                                  let retValue;

                try {
                  if(BaseConfiguration.isDebug) console.log("getExcelFileName");
                    let excelDate=this.$options.filters.formatDate(new Date()); 
                    retValue=pFileName+' - '+excelDate+'.xlsx';
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                          "error in getExcelFileName",
                          err.toString(),
                          "getExcelFileName",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
      }, 

     getJsonExcelFields() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getJsonExcelFields");
        let fields;

        fields = {
          "Booking Date & Time": {
            callback: value => {
              let retval =
                this.$options.filters.formatDate(value.arrdate) + ' '+
                value.arrtime.substring(0,5);

              return retval;
            }
        },
          "PNR": "pnr",
          "Sector": "sector",
          "Flight Number": "flight_number",
          "Cabin Class": "cabin_type",
          "Booking Class": "booking_class",
          "Departure Date & Time": {
            callback: value => {
              let retval =
                this.$options.filters.formatDate(value.depdate) + ' '+
                value.deptime.substring(0,5);

              return retval;
            }
        },
          "Pax Name": {
            callback: value => {
              let retval =
                value.firstname + "  " + value.lastname;

              return retval;
            }
        },
          "Gender" : "gender",
          "Pax Type": "paxtype",
          "Date of Birth": "dob",
          "Doc Type": "id_type",
          "Doc ID": "id_number",
          "Doc ID Expiry Date": "id_expirydate",
          "Contact No.": {
            callback: value => {
              let retval ;
              if(value.contact_mobile_code){
                retval = value.contact_mobile_code + "  " + value.contact_mobile_number;
              }
              else{
                retval = value.contact_mobile_number;
              }
              return retval;
            }
        },
          "Mail ID": "contact_email",
          "Ticket Number": "ticket_number",

        };

        retValue = fields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in getJsonExcelFields",
          err.toString(),
          "getJsonExcelFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

     toggleJsonExcelModal() {
      this.showJsonExcelModal = !this.showJsonExcelModal;
    },


     onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.tableFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
             COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 

      cityPickCustomeLabel(option) {
      return `${option.depcode.city} — [${option.depcode.airportcode}]`;
    },

     getTravelDate(pDate, isFromDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getDate");
                    // let retValue;
                    if (pDate) {
                        if (isFromDate == true) {
                            this.travelDateFrom = new Date(pDate);
                            this.travelDateTo = null;
                        }
                        if (isFromDate == false)
                            this.travelDateTo = new Date(pDate);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getDate",
                        err.toString(),
                        "getDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

               clearFilter() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearFilter");
                    //let retValue;
                    this.reportObj.contractIds = null;
                    this.reportObj.flightNumber = null;
                    this.reportObj.depTime = null;
                    this.reportObj.reportEndDate = null;
                    this.reportObj.reportStartDate = null;
                    this.reportObj.pnr = null;
                    this.reportObj.depCode = null;
                    this.reportObj.arrCode = null;
                    this.travelDateFrom = null;
                    this.travelDateTo = null;
                    this.reportObj.ticketNumber = null;
                    this.bookingDateFrom = null;
                    this.bookingDateTo = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                       COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in clearFilter",
                        err.toString(),
                        "clearFilter",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

      onChangeTravelDate(pDateList) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onChangeTravelDate");
                    //  console.error(pDateList)
                    //    this.fromDate=pDateList[0]._d;
                    this.getTravelDate(pDateList[0]._d,true);
                    this.getTravelDate(pDateList[1]._d,false);
                    //  this.toDate=pDateList[1]._d;
                    //  this.onToggleTravelDatePicker();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in onChangeTravelDate",
                        err.toString(),
                        "onChangeTravelDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onToggleTravelDatePicker() {
     try {
       if(BaseConfiguration.isDebug) console.log("onToggleTravelDatePicker");
       this.isTravelDatePickerOpen=!this.isTravelDatePickerOpen;
       if(this.isTravelDatePickerOpen){
       addClassToBody(this.$router.currentRoute.name+' '+'overflow-hidden')
       }else{
       addClassToBody(this.$router.currentRoute.name)
       }
     } catch (err) {
             let body = Logger.buildRequest(
               COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
               "error in onToggleTravelDatePicker",
               err.toString(),
               "onToggleTravelDatePicker",
               LOG_TYPE.ERROR
             );
             Logger.getResponse(body);
           }
     }, 
    

                 getBookingDate(pDate, isFromDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getDate");
                    // let retValue;
                    if (pDate) {
                        if (isFromDate == true) {
                            this.bookingDateFrom = new Date(pDate);
                            // if(this.bookingDateFrom){
                      // this.$refs.manifestdatePicker.togglePicker();
                    // }
                            this.bookingDateTo = null;
                        }
                        if (isFromDate == false)
                            this.bookingDateTo = new Date(pDate);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getDate",
                        err.toString(),
                        "getDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            
getBookingDateForm(){
  console.log(this.$refs.manifestdatePicker)
},

            onChangeBookingDate(pDateList) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onChangeBookingDate");
                    //  console.error(pDateList)
                    //    this.fromDate=pDateList[0]._d;
                    if(pDateList){
                    this.getBookingDate(pDateList[0]._d,true);
                    
                    this.getBookingDate(pDateList[1]._d,false);
                    }
                    //  this.toDate=pDateList[1]._d;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in onChangeBookingDate",
                        err.toString(),
                        "onChangeBookingDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getMinYear() {
                let retValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getMinYear");
                    retValue=(new Date().getFullYear()-10)+'';

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getMinYear",
                        err.toString(),
                        "getMinYear",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getMaxYear(isTravelDate) {
                let retValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getMaxYear");
                    retValue=isTravelDate?(new Date().getFullYear()+10)+'':(new Date().getFullYear()+1)+'';

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getMaxYear",
                        err.toString(),
                        "getMaxYear",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

      onPaginationChange(pItemsPerPage) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onPaginationChange");
                    this.manifestTableWatchList.itemsPerPage=pItemsPerPage;

                } catch (err) {
                    let body = Logger.buildRequest(
                       COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in onPaginationChange",
                        err.toString(),
                        "onPaginationChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

             getFilteredAgentCount(pFilteredItems) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
                    this.manifestTableWatchList.filteredlistCount=pFilteredItems.length;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getFilteredAgentCount",
                        err.toString(),
                        "getFilteredAgentCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

             ///to change class of city picker
            addCssClass() {
                //
                try {
                    if (BaseConfiguration.isDebug) console.log("addCssClass");

                    let countryTitleLIst = document.getElementsByClassName(
                        "multiselect__option--disabled"
                    );
                    setTimeout(() => {
                        for (let index = 0; index < countryTitleLIst.length; index++) {
                            const element = countryTitleLIst[index];
                            element.parentNode.classList.add("active");
                        }
                    },100);

                } catch (error) {
                    //ignore
                }
            },

               
            
            getArrivalRoute(pArrival) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getArrivalRoute");
                    if(pArrival&&pArrival.depcode&&pArrival.depcode.airportcode){
                        // this.reportObj.arrCode=  pArrival.depcode.airportcode;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getArrivalRoute",
                        err.toString(),
                        "getArrivalRoute",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            onPageChange(pPageNum) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onPageChange");
                    this.manifestTableWatchList.currentPageNum=pPageNum;
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in onPageChange",
                        err.toString(),
                        "onPageChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


       getDepartureRoute(pDeparture) {
                try {
                    if(BaseConfiguration.isDebug) console.log("getDepartureRoute");
                    if(pDeparture&&pDeparture.depcode&&pDeparture.depcode.airportcode){
                        // this.reportObj.depCode=  pDeparture.depcode.airportcode;

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in getDepartureRoute",
                        err.toString(),
                        "getDepartureRoute",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

             async onContractChange(pContractObj) {
                try {
                  if(BaseConfiguration.isDebug) console.log("onContractChange");
                
                   let contractIds = [];
                   for (let i = 0; i < this.reportObj.contractIds.length; i++) {
                    contractIds.push(Number(this.reportObj.contractIds[i].contractid))
                     
                   }
                 
                  // this.lsFlightTime = await this.getFlightNum(contractIds);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                           COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                          "error in onContractChange",
                          err.toString(),
                          "onContractChange",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
          },

           async onChangeFlightNumber(pFlightNum) {
                try {
                  if(BaseConfiguration.isDebug) console.log("onChangeFlightNumber");
                  this.reportObj.flightNumber = pFlightNum;
                  this.reportObj.depTime=null
                  this.lsFlightTime = await this.getFlightTiming(this.reportObj.flightNumber);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                           COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                          "error in onChangeFlightNumber",
                          err.toString(),
                          "onChangeFlightNumber",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
          }, 

            getReqForReport(pReportObj) {
               let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("getReqForReport");
                 retValue = cloneDeep(pReportObj);
                 retValue.depCode = retValue.depCode?retValue.depCode.depcode.airportcode:null;
                 retValue.arrCode = retValue.arrCode?retValue.arrCode.depcode.airportcode:null;
                 retValue.flightNumber = retValue.flightNumber?retValue.flightNumber.flight_number:null;
                 retValue.depTime = retValue.depTime?retValue.depTime.deptime:null;
                 if(retValue.contractIds && retValue.contractIds.length!=0){
                   let contrctId = cloneData(retValue.contractIds)
                   retValue.contractIds=[]
                   for (let i = 0; i < contrctId.length; i++) {
                     retValue.contractIds.push(Number(contrctId[i].contractid))
                     
                   }
                 }
                  else{
                    retValue.contractIds = null
                  }
                  retValue.depDate = formatDate( this.travelDateFrom,DATE_TIME_FORMAT.API_DATE_FORMAT);
                  retValue.reportStartDate = formatDate( this.bookingDateFrom,DATE_TIME_FORMAT.API_DATE_FORMAT);
                  retValue.reportEndDate = formatDate( this.bookingDateTo,DATE_TIME_FORMAT.API_DATE_FORMAT);
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                          "error in getReqForReport",
                          err.toString(),
                          "getReqForReport",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 

   

    async getBookingManifest() {
                if (BaseConfiguration.isDebug) console.log("getBookingManifest");
                let returnValue;
                try {
                  let reqBody =  this.getReqForReport(this.reportObj)
                    let bookingManifestReq = apiBookingManifestReport.buildRequest(reqBody);
                   
                    if (bookingManifestReq != null) {
                        let bookingManifestRes = await apiBookingManifestReport.getResponse(bookingManifestReq);
                        if (VALIDATE_SUCCESS_RES(bookingManifestRes)) {
                            this.alertValue = null;
                            returnValue = bookingManifestRes.data.data.report;
                            
                        } else {
                            let error = getErrorMessage(bookingManifestRes);
                            
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error in  getBookingManifest",
                        err.toString(),
                        "getBookingManifest",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },

             ///to get number of routes response from api
            async getRoutesResponse() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

                    let getRoutesRequest = apiGetRoutes.buildRequest();

                    if (getRoutesRequest) {
                        // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
                        let getRouteResponse = await apiGetRoutes.getResponse(
                            getRoutesRequest
                        );

                        if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
                            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

                            retValue = getRouteResponse.data.data;
                            // this.SET_ROUTES_OBJ(retValue);
                        } else {
                            let error = getErrorMessage(getRouteResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error while getting response from get Routes response API",
                        err.toString(),
                        "getRoutesResponse",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            ///method to get routes for particular country
            getRoutesByCountryCode() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesByCountryCode");

                    // this.lsCountryRoute = []; //to clear the list

                    let countries = this.routesResponse.countries;
                    let airports = this.routesResponse.airports;
                    let routes = this.routesResponse.routes;
                    let listOfRoutes = [];

                    var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode
                    for (let i = 0; i < Object.keys(countries).length; i++) {
                        for (let j = 0; j < Object.keys(airports).length; j++) {
                            let lsArrCodes = [];
                            if (
                                Object.values(countries)[i].countrycode ==
                                Object.values(airports)[j].countryid
                            ) {
                                for (let k = 0; k < routesGrpByList.length; k++) {
                                    if (
                                        routesGrpByList[k].depcode ==
                                        Object.values(airports)[j].airportcode
                                    ) {
                                        for (
                                            let l = 0;
                                            l < routesGrpByList[k].arrCombination.length;
                                            l++
                                        ) {
                                            lsArrCodes.push(
                                                routesGrpByList[k].arrCombination[l].arrcode
                                            );
                                        }
                                    }
                                }

                                let lsArrCodesForDep = {
                                    // "routes": 1,
                                    depcode: Object.values(airports)[j],
                                    arrcode: lsArrCodes
                                }; ///list of arrival for particular departure

                                listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
                            }
                        }

                        let countryRoute = {
                            country: Object.values(countries)[i],
                            routeList: listOfRoutes
                        };
                        listOfRoutes = [];
                        this.lsCountryRoute.push(countryRoute);
                    }
                    let startCountry = cloneData(this.lsCountryRoute[0]);
                    for (let index = 0; index < this.lsCountryRoute.length; index++) {
                        const countryObj = this.lsCountryRoute[index];
                        if(countryObj.country.countrycode==BaseConfiguration.defaultCountryValue){
                            this.lsCountryRoute[0]=countryObj;
                            this.lsCountryRoute[index]=startCountry;
                            break;
                        }

                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                        "error while formatting routes",
                        err.toString(),
                        "getRoutesByCountryCode",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

   async GetAllContract() {
      if (BaseConfiguration.isDebug) console.log("GetAllContract");
      let returnValue;
      try {
        let GetAllContractReq = apiGetAllContract.buildRequest(); //constant

        if (GetAllContractReq != null) {
          let GetAllContractRes = await apiGetAllContract.getResponse(
            GetAllContractReq
          );
          if (VALIDATE_SUCCESS_RES(GetAllContractRes)) {
                        this.alertValue=null;
            returnValue = GetAllContractRes.data.data.contractList;
          } else {
            let error = getErrorMessage(GetAllContractRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in  getGetAllContract",
          err.toString(),
          "getGetAllContract()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

      async getFlightNum(pContractIds) {
      if (BaseConfiguration.isDebug) console.log("getFlightNum");
      let returnValue;
      try {
        let getFlightNumReq = apiCrsFlightNumwithRoute.buildRequest(pContractIds); //constant

        if (getFlightNumReq != null) {
          let getFlightNumRes = await apiCrsFlightNumwithRoute.getResponse(
            getFlightNumReq
          );
          if (VALIDATE_SUCCESS_RES(getFlightNumRes)) {
                        this.alertValue=null;
            returnValue = getFlightNumRes.data.data.flightNumbers;
            let i=0;
            returnValue.forEach(item => {
             item["id"] = i;
             i++;
          });
          } else {
            let error = getErrorMessage(getFlightNumRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in  getFlightNum",
          err.toString(),
          "getFlightNum()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getFlightTiming(pflightNumObj) {
      if (BaseConfiguration.isDebug) console.log("getFlightTiming");
      let returnValue;
      try {
        let getFlightTimingReq = apiCrsFlightTimingwithRoute.buildRequest(pflightNumObj); //constant

        if (getFlightTimingReq != null) {
          let getFlightTimingRes = await apiCrsFlightTimingwithRoute.getResponse(
            getFlightTimingReq
          );
          if (VALIDATE_SUCCESS_RES(getFlightTimingRes)) {
                        this.alertValue=null;
            returnValue = getFlightTimingRes.data.data.flightTimings;
            let i=0;
            returnValue.forEach(item => {
             item["id"] = i;
             i++;
          });
          } else {
            let error = getErrorMessage(getFlightTimingRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue=getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in  getFlightTiming",
          err.toString(),
          "getFlightTiming()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },


    getReportTableFields() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getReportTableFields");
        retValue = [
          {
            key: "bookingDatetime",
            label: this.$t("bookingManifest.bookingDateTime"),
            isLocked: true,
          },

          {
            key: "pnr",
            label: this.$t("bookingManifest.colPnr"),
            isLocked: false,
          },

          {
            key: "sector",
            label: this.$t("bookingManifest.colSector"),
            isLocked: false,
          },
          {
            key: "flight_number",
            label: this.$t("bookingManifest.flightNum"),
            isLocked: false,
          },
          {
            key: "cabin_type",
            label: this.$t("bookingManifest.cabinClass"),
            isLocked: false,
          },
          {
            key: "booking_class",
            label: this.$t("bookingManifest.bookingclass"),
            isLocked: false,
          },
          {
            key: "depDateTime",
            label: this.$t("bookingManifest.depDatetime"),
            isLocked: true,
          },
          {
            key: "paxName",
            label: this.$t("bookingManifest.paxName"),
            isLocked: false,
          },
          {
            key: "gender",
            label: this.$t("bookingManifest.gender"),
            isLocked: false,
          },
          {
            key: "paxtype",
            label: this.$t("bookingManifest.paxType"),
            isLocked: false,
          },
          {
            key: "dob",
            label: this.$t("bookingManifest.dob"),
            isLocked: false,
          },
          {
            key: "id_type",
            label: this.$t("bookingManifest.docType"),
            isLocked: false,
          },
          {
            key: "id_number",
            label: this.$t("bookingManifest.docID"),
            isLocked: false,
          },
          {
            key: "id_expirydate",
            label: this.$t("bookingManifest.expryDate"),
            isLocked: false,
          },
          {
            key: "mobilenumber",
            label: this.$t("bookingManifest.contactNo"),
            isLocked: false,
          },

          {
            key: "contact_email",
            label: this.$t("bookingManifest.mail"),
            isLocked: false,
          },
          {
            key: "ticket_number",
            label: this.$t("bookingManifest.ticketNum"),
            isLocked: true,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
          "error in getReportTableFields",
          err.toString(),
          "getReportTableFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async onApply() {
        try {
          if(BaseConfiguration.isDebug) console.log("onApply");
          this.isFiltersApplied=true;
          this.manifestLs = await this.getBookingManifest();
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
                  "error in onApply",
                  err.toString(),
                  "onApply",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
    }, 
  },
  computed: {
     DATE_TIME_FORMAT() {
                return DATE_TIME_FORMAT;
            }
  },
      beforeCreate() {    
   addClassToBody(COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      
       this.contractLs = await this.GetAllContract();
       this.lsFlightNum = await this.getFlightNum();
       this.routesResponse = await this.getRoutesResponse();
            if (this.routesResponse != null) {
                this.getRoutesByCountryCode();
            }
            this.tableFields = this.getReportTableFields();
            
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_BOOKING_MANIFEST_REPORT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style>
</style>